// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"preview_detailsWrapper__5p9L1","iframeWrapper":"preview_iframeWrapper__u42oH","statSummary":"preview_statSummary__ybJoF","item":"preview_item__rltIp"};